import { signInWithEmailAndPassword } from 'firebase/auth';
import { createUser } from './helpers';
import { FirebaseProviderAuthenticationError } from './errors';

export default function signInWithEmailAndPasswordFactory(
  auth,
  email,
  password
) {
  return signInWithEmailAndPassword(auth, email, password)
    .then(userCredentials => createUser(userCredentials.user))
    .catch(error => {
      throw new FirebaseProviderAuthenticationError(error);
    });
}
